// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "bootstrap/dist/js/bootstrap.bundle"
import "chartkick/chart.js"
import "./controllers"
import { post } from "@rails/request.js"

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

Chartkick.configure({language: "de"})

// window.alertSuccess = function(message) {
//   const alert = document.createElement("template")
//   alert.dataset["controller"] = "alert"
//   alert.dataset["alertTypeValue"] = "success"
//   alert.dataset["alertMessageValue"] = message

//   document.body.append(alert)
// }

// window.alertDanger = function(message) {
//   const alert = document.createElement("template")
//   alert.dataset["controller"] = "alert"
//   alert.dataset["alertTypeValue"] = "danger"
//   alert.dataset["alertMessageValue"] = message

//   document.body.append(alert)
// }
